import React from 'react'
import { Headings } from '../../components';
import { FiMail, FiMapPin } from 'react-icons/fi';
import './Contact.css';
const Contact = () => {
  return (
    <section className="contact-section section-padding" id="quote">
      <div className="site-container">
        <Headings title="Talk to SmartSastram" text="Share the enterprise AI workflow, Dataface.ai partnership idea, or product problem you want to explore." />

        <div className="contact">
          <div className="contact-info">
            <span className="eyebrow">Enterprise AI conversations</span>
            <h3>Bring a workflow. We will help shape the AI product path.</h3>
            <p>
              The best starting point is a specific data, evaluation, or decision workflow where AI can create measurable value.
            </p>
            <ul>
              <li><FiMail /> <a href="mailto:contact@smartsastram.com">contact@smartsastram.com</a></li>
              <li><FiMapPin /> Hyderabad, India</li>
            </ul>
          </div>

          <form action="mailto:contact@smartsastram.com" method="post" encType="text/plain" className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name*</label>
              <input className="form-control" id="name" name="name" type="text" placeholder="Your name" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email*</label>
              <input className="form-control" id="email" name="email" type="email" placeholder="you@company.com" required />
            </div>
            <div className="form-group">
              <label htmlFor="company">Company</label>
              <input className="form-control" id="company" name="company" type="text" placeholder="Company name" />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message*</label>
              <textarea className="form-control" id="message" name="message" rows="5" placeholder="Tell us about the workflow, product, or AI system you want to build." required />
            </div>
            <button type="submit" className="btn-positivus w-100">Send inquiry</button>
          </form>
        </div>
      </div>
    </section>
  )
}

export default Contact
